<template>
  <div class="avatar-block">
    {{ /* Temporary block to support migration from old layout */ }}
    <avatar :image="icon" :alt-text="app.name">
      <h1 class="avatar-block__name">{{ app.name }}</h1>
    </avatar>
  </div>
</template>

<script>
import { mapState } from "vuex"

import { getImageUrl } from "@/lib/utils"

import Avatar from "@/components/Avatar"

export default {
  components: {
    Avatar
  },

  computed: {
    ...mapState(["global"]),

    app() {
      return this.global?.app || {}
    },

    icon() {
      return this.app.icon || {}
    }
  },

  methods: {
    getImageUrl
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.avatar-block__name {
  margin-left: $size--3;
  margin-bottom: $size--2;
  margin-top: $size--5;
  font-size: 1.4rem;
  align-self: flex-end;
}
</style>
